import { useEffect } from 'react'

export const useCountryInputHandlers = ({
  countries,
  setFilteredCountries,
  setShowDropdown,
  setHighlightedIndex,
  setDestination,
  setCountryQuery,
  setErrorSelect,
  filteredCountries,
  setErrorInputPostalCode,
  highlightedIndex,
  setInputError,
}) => {

  const handleCountrySelect = (country) => {
    setCountryQuery(country.label)
    setDestination(country.value)
    setFilteredCountries([])
    setShowDropdown(false)
    setHighlightedIndex(-1)
    setErrorSelect(null)
    setErrorInputPostalCode(null)
    setInputError(null)
  }

  const handleCountryInputChange = (event) => {
    const value = event.target.value
    setCountryQuery(value)
    setHighlightedIndex(-1)
    if (value.length > 0) {
      const filtered = countries.filter(country =>
        country.label.toLowerCase().includes(value.toLowerCase())
      )
      setFilteredCountries(filtered)
      setErrorSelect(null)
    } else {
      setFilteredCountries(countries)
      setDestination('')
    }
    setShowDropdown(true)
  }

  const handleInputFocus = () => {
    setErrorSelect(null)
    setFilteredCountries(countries)
    setShowDropdown(true)
  }

  const handleKeyDown = (event) => {
    setErrorSelect(null)
    if (filteredCountries.length === 0) return

    if (event.key === "ArrowDown") {
      setHighlightedIndex((prev) => Math.min(prev + 1, filteredCountries.length - 1))
    } else if (event.key === "ArrowUp") {
      setHighlightedIndex((prev) => Math.max(prev - 1, 0))
    } else if (event.key === "Enter" && highlightedIndex >= 0) {
      event.preventDefault()
      handleCountrySelect(filteredCountries[highlightedIndex])
    }
  }

  const handleClickOutside = (event) => {
    if (!event.target.closest(".country-dropdown")) {
      setShowDropdown(false)
    }
  }

  useEffect(() => {
    document.addEventListener("click", handleClickOutside)
    return () => document.removeEventListener("click", handleClickOutside)
  }, [])

  return {
    handleCountryInputChange,
    handleInputFocus,
    handleKeyDown
  }
}